import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './TaskEmptyState.module.css';

const TaskEmptyState = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.emptyState}>
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M9 11l3 3L22 4" />
        <path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11" />
      </svg>
      <h3>{t('records.views.task.empty.title')}</h3>
      <p>{t('records.views.task.empty.description')}</p>
    </div>
  );
};

export default TaskEmptyState;
